<template>
  <button
    :class="`social-button network-${network}`"
    v-html="image[network]"
    @click="handleClick"
  />
</template>

<script>
import share from 'lib/share';
import facebook from 'assets/image/facebook.svg';
import twitter from 'assets/image/twitter.svg';

export default {
  props: {
    network: String,
  },
  data: () => ({
    image: {
      facebook,
      twitter,
    },
  }),
  methods: {
    handleClick() {
      share(this.network);
    },
  },
};
</script>

<style lang="scss" scoped>
  button {
    background: transparent;
    border: none;
    cursor: pointer;
    margin: 0;
    padding: 0;
    vertical-align: middle;

    &:not(:first-child) {
      margin-left: 1rem;
    }
  }
</style>

<style lang="scss">
  .social-button {
    $facebook-color: #3b5998;
    $twitter-color: #55acee;

    svg {
      fill: red;
      width: 60px;
    }

    &.network-facebook svg {
      fill: $facebook-color;
    }

    &:hover.network-facebook svg {
      fill: darken($facebook-color, 15%);
    }

    &.network-twitter svg {
      fill: $twitter-color;
    }

    &:hover.network-twitter svg {
      fill: darken($twitter-color, 15%);
    }
  }

</style>



// WEBPACK FOOTER //
// SocialButton.vue?fb4e7e80